/* 🤖 this file was generated by svg-to-ts*/
export const icoWrench: {
  name: 'wrench';
  data: string;
} = {
  name: 'wrench',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 2A6.5 6.5 0 009 8.5l.009.343c.018.341.062.679.132 1.01l.011.044L2.55 16.5a2 2 0 000 2.828l2.122 2.122.127.117A2 2 0 007.5 21.45l6.602-6.603.045.012a6.5 6.5 0 007.537-8.365l-.503-1.553L17.5 8.62 15.379 6.5l3.681-3.68-1.553-.504A6.496 6.496 0 0015.5 2zm-.628 2.043l.153-.018L12.55 6.5l4.95 4.95 2.474-2.475-.017.153a4.5 4.5 0 01-5.846 3.654l-.583-.189-7.442 7.442-2.122-2.12 7.443-7.443-.189-.583a4.501 4.501 0 013.654-5.846z" fill="#909090"/></svg>`
};
